import { REQUIRED_FIELD } from "constants/validator-messages";
import * as yup from "yup";

export const customStatusValidationSchema = yup.object().shape({
  name: yup.string().required(REQUIRED_FIELD),
  stageId: yup.number().required(REQUIRED_FIELD),
});
